import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Thumbnail } from "@/components/cmrReport/Thumbnail"
import { humanizeDocumentType } from "@/lib/gpsDocumentLinks"
import type { GpsOrderDocument } from "./useGpsOrderDocuments"
import { useTranslation } from "react-i18next"

export function OrderDocumentsDialog({
  orderName,
  documents,
  onClose,
  onOpenDocument,
}: {
  orderName: string
  documents: GpsOrderDocument[]
  onClose: () => void
  onOpenDocument: (document: GpsOrderDocument) => void
}) {
  const { t } = useTranslation()
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("orders.orderDocuments.title")}</DialogTitle>
          <DialogDescription>{orderName}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-3">
          {documents.map((document) => (
            <Thumbnail
              key={document.messageId || document.fileUrl}
              url={document.fileUrl}
              fileName={document.fileName}
              documentType={humanizeDocumentType(document.documentType)}
              timestamp={document.timestamp}
              showDate
              onClick={() => onOpenDocument(document)}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
